import Offer from './Offer';
import Offers from './Offers';
import ButtonMerchants from './ButtonMerchants';
import Categories from './Categories';
import CloOffer from './CloOffer';
import Clo from './Clo';

export const loyalty = {
  routes: [{
    component: Offers,
    path: '/offers',
    exact: true,
  }, {
    component: Offer,
    path: '/offers/:offerId',
    exact: true,
  }, {
    component: ButtonMerchants,
    path: '/button',
    exact: true,
  }, {
    component: Categories,
    path: '/categories',
    exact: true,
  }, {
    component: Clo,
    path: '/clo',
    exact: true,
  }, {
    component: CloOffer,
    path: '/offers/clo/:offerId',
    exact: true,
  }],
};
